import { render, staticRenderFns } from "./IspNegative.vue?vue&type=template&id=28c03ed1&scoped=true&"
import script from "./IspNegative.vue?vue&type=script&lang=js&"
export * from "./IspNegative.vue?vue&type=script&lang=js&"
import style0 from "./IspNegative.vue?vue&type=style&index=0&id=28c03ed1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c03ed1",
  null
  
)

export default component.exports